import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import ENDPOINTS from '../../constants/endpoints';
import { client } from '../../helper/apiCall';


export const getOwners = createAsyncThunk(
    'owner/getOwners',
    async (_, thunkAPI) => {
        try {
            const response = await client.get(ENDPOINTS.OWNER.GET_LIST, {
                token: thunkAPI.getState().auth.token
            });
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const createOwner = createAsyncThunk(
    'owner/createOwner',
    async (owner, thunkAPI) => {
        try {
            const response = await client.post(ENDPOINTS.OWNER.CREATE, owner, {
                token: thunkAPI.getState().auth.token
            });
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const updateOwner = createAsyncThunk(
    'owner/updateOwner',
    async (owner, thunkAPI) => {
        try {
            const response = await client.put(ENDPOINTS.OWNER.UPDATE, owner, {
                token: thunkAPI.getState().auth.token
            });
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const deleteOwner = createAsyncThunk(
    'owner/deleteOwner',
    async (id, thunkAPI) => {
        try {
            const response = await client.delete(ENDPOINTS.OWNER.DELETE.replace(':id', id), {}, {
                token: thunkAPI.getState().auth.token,
            });
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

const ownerSlice = createSlice({
    name: 'owner',
    initialState: {
        loading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getOwners.pending, (state) => {
                state.loading = true;
            })
            .addCase(getOwners.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(getOwners.rejected, (state, action) => {
                state.loading = false;
            });
        builder
            .addCase(createOwner.pending, (state) => {
                state.loading = true;
            })
            .addCase(createOwner.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(createOwner.rejected, (state, action) => {
                state.loading = false;
            });
        builder
            .addCase(updateOwner.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateOwner.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(updateOwner.rejected, (state, action) => {
                state.loading = false;
            });
        builder
            .addCase(deleteOwner.pending, (state) => {
                state.loading = true;
            })
            .addCase(deleteOwner.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(deleteOwner.rejected, (state, action) => {
                state.loading = false;
            });
    }
});

export default ownerSlice.reducer;


